import { useCallback, useEffect, useState } from "react";
import { CreditCard } from "lucide-react";
import { api } from "../../lib/api";

// Founder-only: email → most relevant plan request (active > priced) so rows
// can flag clients who already have a payment link out.
export function usePlanSentMap(enabled) {
  const [map, setMap] = useState({});
  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const { data } = await api.get("/admin-auth/subscriptions");
      const next = {};
      for (const r of data.requests || []) {
        if (!r.payment_link_url || r.status === "cancelled") continue;
        const key = (r.email || "").toLowerCase();
        const prev = next[key];
        if (!prev || (r.status === "active" && prev.status !== "active")) next[key] = r;
      }
      setMap(next);
    } catch { /* non-critical */ }
  }, [enabled]);
  useEffect(() => { refresh(); }, [refresh]);
  return [map, refresh];
}

export default function PlanSentChip({ req, testid }) {
  if (!req) return null;
  const active = req.status === "active";
  const when = req.priced_at ? new Date(req.priced_at).toLocaleDateString() : "";
  return (
    <span
      data-testid={testid}
      title={`${req.plan_name} · $${Number(req.custom_amount || 0).toLocaleString()}${req.billing === "monthly" ? "/mo" : " one-time"}${when ? ` · sent ${when}` : ""}`}
      className={`shrink-0 inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[9px] uppercase tracking-[0.2em] ${active ? "bg-[#1e3d3a] text-[#c9a961]" : "bg-[#c9a961]/18 text-[#a3823f]"}`}
    >
      <CreditCard className="h-3 w-3" /> {active ? `${req.plan_name} · paid` : `${req.plan_name} sent`}
    </span>
  );
}
